const pt = {
  // Navegação
  nav: {
    home: 'Início',
    about: 'Sobre',
    experience: 'Experiência',
    projects: 'Projetos',
    contact: 'Contacto',
  },

  // Secção Hero
  hero: {
    greeting: 'Especialista em Cibersegurança',
    titles: ['Especialista em Cibersegurança', 'Analista SOC Nível 1', 'Entusiasta de Hacking Ético'],
    description: 'Automação de segurança, monitorização de ameaças e defesa para sistemas modernos.',
    viewProjects: 'Ver Projetos',
    downloadCV: 'Descarregar CV',
  },

  // Secção Sobre
  about: {
    title: 'Sobre',
    description: 'Chamo-me Diogo Cunha, tenho 24 anos e sou Militar da Força Aérea Portuguesa. Sou Especialista em Cibersegurança com mais de 3 anos em operações de defesa, focado em monitorização, threat hunting e automação de segurança. Tenho forte experiência em Python e segurança de redes, desenvolvendo ferramentas práticas e sistemas resilientes. Comecei nesta área por ter muito interesse em tecnologia, o que me levou a seguir o caminho da cibersegurança. O meu objetivo é adquirir o máximo de conhecimento possível e crescer tanto profissionalmente como pessoalmente.',
    stats: {
      experience: 'Anos de Experiência',
      certifications: 'Certificações',
      projects: 'Projetos de Segurança',
    },
    highlightsTitle: 'O Que Ofereço',
    highlights: {
      securityOps: {
        title: 'Operações de Segurança',
        description: 'Trabalho prático de defesa em monitorização, investigação e resposta a incidentes com mentalidade baseada em risco.',
      },
      threatAnalysis: {
        title: 'Análise de Ameaças e Malware',
        description: 'Triagem e análise para compreender comportamentos, reduzir exposição e melhorar playbooks de deteção e resposta.',
      },
      automation: {
        title: 'Automação e Ferramentas',
        description: 'Construção de ferramentas práticas que simplificam trabalho repetitivo e transformam insights de segurança em workflows repetíveis.',
      },
    },
  },

  // Secção Experiência
  experience: {
    title: 'Experiência',
    subtitle: 'O meu percurso na indústria de cibersegurança e TI',
    tabs: {
      professional: 'Profissional',
      academic: 'Académico',
      certifications: 'Certificações',
    },
    jobs: {
      cybersecuritySpecialist: {
        title: 'Especialista em Cibersegurança',
        company: 'Força Aérea Portuguesa',
        responsibilities: [
          'Análise e deteção de malware',
          'Avaliação de vulnerabilidades',
          'Cibersegurança e operações defensivas',
          'Python, HTML e programação',
          'Sistemas operativos, bases de dados e redes',
          'Penetration testing',
        ],
      },
      complianceAnalyst: {
        title: 'Especialista de Compliance',
        company: 'Leica Microsystems',
        responsibilities: [
          'Gestão de sistemas SAP',
          'Análise de dados em Excel',
          'Relatórios e documentação de compliance',
        ],
      },
      itConsultant: {
        title: 'Consultor de TI',
        company: 'Inetum',
        responsibilities: [
          'Suporte e consultoria ao cliente',
          'Integração de sistemas',
        ],
      },
      itTechnician: {
        title: 'Técnico de TI',
        company: 'Claranet',
        responsibilities: [
          'Instalação de Equipamentos TI',
          'Preparação de equipamentos para instalação',
          'Configuração de IP em Impressoras',
          'Configuração e setup de computadores na rede',
        ],
      },
    },
    education: {
      cybersecurity: {
        degree: 'Cibersegurança',
        institution: 'ISTEC',
        level: 'Técnico Nível 5',
        description: 'Estudos avançados em cibersegurança, focando em penetration testing, defesa de rede e arquitetura de sistemas seguros.',
      },
      programming: {
        degree: 'Técnico de Gestão e Programação de Sistemas Informáticos',
        institution: 'Escola Secundária Leal da Câmara',
        level: 'Qualificação Nível 4',
        description: 'Fundamentos em sistemas informáticos, programação e gestão de TI.',
      },
    },
    certifications: [
      { name: 'Cyber Defender Final Examination', issuer: 'MILE2', year: '2024' },
      { name: 'C)ITP: Certified Information Technology Principles', issuer: 'MILE2', year: '2024' },
      { name: 'C)SP: Certified Security Principles', issuer: 'MILE2', year: '2024' },
      { name: 'C)NP: Certified Network Principles', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-NSD: Network Security and Defense', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-IRM: Incident Response and Management', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-TIVM: Threat Intelligence and Vulnerability Management', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-FOC: Foundations of Cybersecurity', issuer: 'MILE2', year: '2024' },
      { name: 'Ethical Hacking Essentials (EHE)', issuer: 'EC-Council', year: '2022' },
      { name: 'Digital Forensics Essentials (DFE)', issuer: 'EC-Council', year: '2023' },
    ],
  },

  // Secção Projetos
  projects: {
    title: 'Projetos em Destaque',
    subtitle: 'Ferramentas de segurança, automação e trabalho de engenharia selecionados.',
    featured: 'Destaque',
    items: {
      blueTeam: {
        title: 'Scripts de Defesa Blue Team',
        description: 'Coleção de scripts Python desenhados para monitorização e operações de defesa em cibersegurança. Ferramentas automatizadas para deteção de ameaças, análise de logs e resposta a incidentes em operações blue team.',
        overlay: 'Defesa Blue Team',
      },
      carapauCracker: {
        title: 'CarapauCracker - Ferramenta de Análise de Segurança',
        description: 'Framework avançado de análise e testes de segurança baseado em Python. Desenvolvido para penetration testing e avaliação de vulnerabilidades com capacidades de shell scripting automatizado.',
        overlay: 'Análise de Segurança',
      },
      writeUpPage: {
        title: 'Write-Up Page',
        description: 'Página dedicada à organização e publicação de write-ups de segurança, desafios e análises técnicas. Pensada para apresentar conteúdo de forma clara, estruturada e fácil de consultar.',
        overlay: 'Write-Ups',
      },
      sportsAnalysis: {
        title: 'Análise Desportiva',
        description: 'Uma plataforma inspirada no Flashscore, mas com foco em análises mais profundas para trading desportivo — estatísticas detalhadas e probabilidades de resultado para cada encontro.',
        overlay: 'Análise Desportiva',
      },
    },
  },

  // Secção Contacto
  contact: {
    title: 'Entre em Contacto',
    subtitle: 'Aberto a projetos, colaborações e funções de segurança.',
    infoTitle: 'Vamos Conversar!',
    infoText: 'Partilhe uma breve descrição e timeline, e responderei o mais rápido possível.',
    email: 'Email',
    location: 'Localização',
    locationValue: 'Lisboa / Portugal',
    form: {
      name: 'Nome',
      namePlaceholder: 'O seu nome',
      email: 'Email',
      emailPlaceholder: 'O seu email',
      message: 'Mensagem',
      messagePlaceholder: 'A sua mensagem',
      submit: 'Enviar Mensagem',
      success: 'Mensagem enviada com sucesso! Obrigado pelo contacto.',
      errors: {
        nameRequired: 'Por favor introduza o seu nome',
        emailRequired: 'Por favor introduza o seu email',
        emailInvalid: 'Por favor introduza um email válido',
        messageRequired: 'Por favor introduza uma mensagem',
      },
    },
  },

  // Rodapé
  footer: {
    builtWith: 'Construído com React | Portfólio de Cibersegurança',
    role: 'Especialista em Cibersegurança | Desenvolvedor Full Stack',
  },
};

export default pt;
